import { ReactElement, ReactNode } from 'react';

import classNames from 'classnames';

export const renderWithParagraphs = (plainText?: string, paragrafClassName = 'tw-mb-4') => {
  if (plainText == undefined || plainText.length === 0) {
    return <></>;
  }
  // Replace \r\n and \r with \n for uniformity
  const normalizedText = plainText.replace(/\r\n|\r/g, '\n');

  // Use regex to split by one or more consecutive \n characters,
  // optionally surrounded by whitespaces
  const paragraphs = normalizedText.split(/\s*?\n\s*\n\s*/g);

  return (
    <>
      {paragraphs.map(
        (paragraph: string, paragraphIndex: number): ReactElement => (
          <p
            className={classNames({ [paragrafClassName]: paragraphIndex !== paragraphs.length - 1 })}
            key={paragraphIndex}
          >
            {paragraph
              .split(/\n/)
              .reduce<
                ReactNode[]
              >((acc, line, lineIndex) => [acc, lineIndex > 0 && <br key={lineIndex} />, line.trim()], [])}
          </p>
        )
      )}
    </>
  );
};
